import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface SettingsSectionHeaderProps {
  title: string;
  hint: string;
  icon: LucideIcon;
  actions?: ReactNode;
}

/** Panel header: copy on the start, large section icon on the end. */
export function SettingsSectionHeader({
  title,
  hint,
  icon: Icon,
  actions,
}: SettingsSectionHeaderProps) {
  return (
    <header className="menu-panel__header settings-section-header">
      <div className="menu-panel__header-copy">
        <h2 className="menu-panel__title">{title}</h2>
        <p className="menu-panel__hint">{hint}</p>
      </div>
      <div className="settings-section-header__aside">
        {actions}
        <span className="settings-section-header__icon" aria-hidden>
          <Icon className="h-5 w-5" strokeWidth={2.25} />
        </span>
      </div>
    </header>
  );
}
